import { render } from "./UserSidebar.vue?vue&type=template&id=6f5ae160&scoped=true"
import script from "./UserSidebar.vue?vue&type=script&lang=js"
export * from "./UserSidebar.vue?vue&type=script&lang=js"

import "./UserSidebar.vue?vue&type=style&index=0&id=6f5ae160&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f5ae160"]])

export default __exports__